export default "__VITE_ASSET__Btn4u5ku__"